import { render, staticRenderFns } from "./BackBtn.vue?vue&type=template&id=f7dc0dee"
import script from "./BackBtn.vue?vue&type=script&lang=ts"
export * from "./BackBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports